/**
 * Proporsi lebar & perataan kolom tabel.
 *
 * `components/table.scss` memberi setiap sel `flex: 1 0 0`, jadi semua kolom
 * mendapat lebar yang sama persis dan isinya dipusatkan. Akibatnya kolom teks
 * terlihat berantakan: nilai pendek dan panjang mulai di titik berbeda karena
 * sama-sama dipusatkan, sehingga tepi kirinya tidak segaris.
 *
 * Dipakai lewat `headerStyle`/`style` milik react-bootstrap-table-next, supaya
 * penyetelan tiap halaman tidak merembet ke tabel halaman lain.
 *
 * `headerStyle` dan `style` harus selalu diberi nilai yang sama; kalau berbeda,
 * judul kolom tidak lagi lurus dengan isinya.
 */

/**
 * @param {number} grow  proporsi lebar kolom terhadap kolom lain
 * @param {"left"|"center"} align  teks rata kiri (default) atau tengah
 */
export const columnLayout = (grow, align = "left") => ({
  flex: `${grow} 1 0`,
  // Tanpa ini flex item menolak menyusut di bawah lebar kontennya, sehingga
  // proporsi di atas diabaikan.
  minWidth: 0,
  justifyContent: align === "center" ? "center" : "flex-start",
  textAlign: align,
});

/**
 * Kolom aksi: lebarnya tetap karena isinya ikon, bukan teks, jadi tidak perlu
 * ikut melebar bersama kolom lain.
 */
export const actionColumnLayout = (width = 128) => ({
  flex: `0 0 ${width}px`,
  justifyContent: "center",
  textAlign: "center",
});
